const ZOOM_SCALAR = 1;
export const FULL_SCREEN_HEIGHT_REM = 71 * ZOOM_SCALAR;
export const FULL_SCREEN_ASPECT_RATIO_MULTIPLIER = 1.414;
export const FULL_SCREEN_WIDTH_REM =
  FULL_SCREEN_HEIGHT_REM * FULL_SCREEN_ASPECT_RATIO_MULTIPLIER;
